<template>
  <div class="dropdown-question main-color">
    <label class="label-2cols q-label" v-html="question.q"></label>
    <md-field class="q-cui-field">
      <md-input
        placeholder="DPI"
        type="number"
        :disabled="readOnly"
        v-model="answer"
        @change="emitValueDPI"
      ></md-input>
    </md-field>
  </div>
</template>

<script>
export default {
  name: "dpi-question",
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      }
    },
    answerProp:{
      type: String,
      default: ""
    },
    readOnly:{
      type:Boolean,
      default: false
    }
  },
  methods: {
    emitValueDPI: function() {
      console.log(this.answer);
      this.$emit("emit-value", { "q_id": this.question.q_id , "q_type": this.question.q_type, "ans": this.answer });
    }
  },
  data: function() {
    return {
      answer: this.answerProp
    };
  }
};
</script>
